// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>17</span>&nbsp;&nbsp;The dead do not praise the Lord,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;nor those gone down into silence;<br> </p> </div></div>";
// Exports
module.exports = code;